import Vue from '../lib/utils/vue3compat/vue.js?vue3';
import GlLicensedFeaturesPlugin from '~/vue_shared/gl_licensed_features_plugin';
import GlFeatureFlagsPlugin from '~/vue_shared/gl_feature_flags_plugin';
import GlAbilitiesPlugin from '~/vue_shared/gl_abilities_plugin';
import Translate from '~/vue_shared/translate';
import { vueErrorHandler } from '~/sentry/vue_error_handler';

if (process.env.NODE_ENV !== 'production') {
  Vue.config.productionTip = false;
}

Vue.use(GlLicensedFeaturesPlugin);

Vue.use(GlFeatureFlagsPlugin);
Vue.use(GlAbilitiesPlugin);
Vue.use(Translate);

Vue.config.ignoredElements = ['gl-emoji'];

if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = vueErrorHandler;
}
